if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) idInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.submitButton = this.querySelector('[type="submit"]');
        this.spinner = this.querySelector('.loading-overlay__spinner');
        this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorWrapper ? this.errorWrapper.querySelector('.product-form__error-message') : null;
        this.cartNotification = document.querySelector('cart-notification');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.handleSubmit(evt);
      }

      handleSubmit(evt) {
        if (evt) evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.setError(false);
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');

        const formData = new FormData(this.form);
        formData.append(
          'sections',
          ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'].join(',')
        );
        formData.append('sections_url', window.location.pathname);

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.setError(response.description || response.message || (window.cartStrings && window.cartStrings.error));
              return;
            }

            if (this.cartNotification) {
              this.cartNotification.renderContents(response);
            } else if (window.routes.cart_url) {
              window.location = window.routes.cart_url;
            }
          })
          .catch(() => {
            this.setError((window.cartStrings && window.cartStrings.error) || 'Something went wrong, please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }

      setError(message) {
        if (!this.errorWrapper) return;
        this.errorWrapper.toggleAttribute('hidden', !message);
        if (message && this.errorMessage) this.errorMessage.textContent = message;
      }
    }
  );
}
